<template>
  <div class="common-page staff-management">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="搜索">
              <el-input
                style="width: 100%"
                clearable
                v-model="searchForm.keyword"
                autocomplete="off"
                placeholder="关键词"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="">
              <el-button type="default" @click="handleReset()">重置</el-button>
              <el-button type="primary" @click="handleCheck()">查询</el-button>
              <el-button type="success" @click="handleAdd()">新增APK</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :custom-height="tableHeight"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange"
      >
        <template v-slot:forceUpdate="{ row }">
          <el-tag v-if="row.forceUpdate">是</el-tag>
          <el-tag type="danger" v-else>否</el-tag>
        </template>
        <template v-slot:operation="{ row }">
          <div>
            <span class="operate-btn" @click.stop="handleEdit(row)">编辑</span>
            <span class="operate-btn" v-if="row.loading"
              ><i class="el-icon-loading"></i
            ></span>
            <span class="operate-btn" @click.stop="handleDown(row)" v-else
              >下载</span
            >
            <span class="operate-btn" @click.stop="handleQr(row)"
              >生成二维码</span
            >
            <!--            <span-->
            <!--              class="operate-btn"-->
            <!--              @click="handleDelete(row.fileId, '确定要删除此配置吗？')"-->
            <!--              >删除</span-->
            <!--            >-->
          </div>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
    <qr ref="qr"></qr>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import qr from "./qr.vue";
import { deleteInfo, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { blobToText, downloadFileCustom } from "@/utils/tool";
import { downloadFile } from "@/views/commonApi";
export default {
  name: "ConfigManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    addOrEdit,
    qr,
  },
  data() {
    return {
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      downloadLoading: false,
      searchForm: {
        keyword: "",
      },
      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "文件名",
          prop: "filename",
          align: "left",
          show: true,
        },
        {
          label: "版本",
          prop: "apkVersion",
          show: true,
        },
        {
          label: "版本描述信息",
          prop: "remark",

          show: true,
        },
        {
          label: "检查更新版本",
          prop: "checkVersion",
          show: true,
        },
        {
          label: "是否强制更新",
          prop: "forceUpdate",
          scopeStatus: true,
          showOverflowTooltip: true,
          show: true,
        },

        {
          label: "创建时间",
          prop: "createTime",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          width: "200px",
          scopeStatus: true,
          fixed: "right",
          show: true,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleQr(row) {
      this.$refs.qr.init(row);
    },
    handleDown(row) {
      row.loading = true;
      downloadFile(row.fileId)
        .then((res) => {
          row.loading = false;

          blobToText(res.data).then((data) => {
            downloadFileCustom(data, row.filename);
          });
        })
        .catch(() => {
          row.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.business-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }
}
</style>
